module.exports = __webpack_public_path__ + "img/score_left.dd5e134e.png";